/**
 * Flutter連携用イベントコールバック関数
 */
export const useFlutterConnection = () => {
  /**
   * @doc    Flutter側で指定URLを新しいWebViewで開く
   * @param  string|null url (ページのURL)
   * @return void
   */
  const openNewWebView = async (url: string | null) => {
    if (!url) return;

    await awaitCallHandler();
    window.flutter_inappwebview.callHandler('openNewWebView', url);
  };

  /**
   * @doc    指定URLをFlutter側で開く
   * @param  string url (ページのURL)
   * @return void
   */
  const launchUrl = async (url: string) => {
    await awaitCallHandler();
    window.flutter_inappwebview.callHandler('launchUrl', url);
  };

  /**
   * @doc    アプリ側に保存されているユーザーIDを取得する
   * @return Promise<number|null>
   */
  const getUserId = async (): Promise<number | null> => {
    try {
      await awaitCallHandler();
      const { id } = await window.flutter_inappwebview.callHandler('getUserId');
      return id;
    } catch (e) {
      // NOTE: Web開発時のためのフォールバック
      if (import.meta.env.MODE == 'stg') return 159; // id of users tables's token: xxxxxxxxxx
      if (import.meta.env.DEV) return 1;
      throw e;
    }
  };

  /**
   * @doc    ユーザーIDをアプリ側に保存する
   * @param  number id (ユーザーID)
   * @return Promise<void>
   */
  const setUserId = async (id: number): Promise<void> => {
    await awaitCallHandler();
    await window.flutter_inappwebview.callHandler('setUserId', id);
  };

  /**
   * @doc    ログをfirebase analyticsに送信する
   * @param  string name (firebase analyticsログイベント名)
   * @param  Record<string, string|number> params (ログの内容)
   * @return Promise<void>
   */
  const logEvent = async (name: string, params: Record<string, string | number>) => {
    await awaitCallHandler();
    await window.flutter_inappwebview.callHandler('logEvent', name, params);
  };

  /**
   * @doc    共通鍵暗号認証アクセスキーを生成する
   * @return Promise<string|null>
   */
  const getAuth = async (): Promise<string | null> => {
    try {
      await awaitCallHandler();
      if (import.meta.env.MODE !== 'prod')
        console.log('getAuth() ', window.flutter_inappwebview.callHandler('getAuth'));
      const token = await window.flutter_inappwebview.callHandler('getAuth');
      if (import.meta.env.MODE !== 'prod') console.log('authkey: ', token);
      return token;
    } catch (e) {
      // NOTE: Web開発時のためのフォールバック
      if (import.meta.env.DEV || import.meta.env.MODE == 'stg')
        return 'cJeFwtmfTjfN57/RcarTrPPjwb+PhUu6RN+D+lNQLEhHoIPTuL8fxR8JR0aEWUzO/J5InnuOzjP8aAk6njAc6Q==';
      throw e;
    }
  };

  /**
   * @doc    ユーザーIDに対応したFCM push通知トークンを発行する
   * @param  number id (ユーザーID)
   * @return Promise<void>
   */
  const registerToken = async (id: number): Promise<void> => {
    try {
      await awaitCallHandler();
      await window.flutter_inappwebview.callHandler('registerToken', id);
    } catch (e) {
      // NOTE: Web開発時のためのフォールバック
      console.log('registerToken :', import.meta.env.DEV);
      if (import.meta.env.DEV || import.meta.env.MODE == 'stg') return;
      throw e;
    }
  };

  /**
   * @doc    ホーム画面が読み込まれたことをFlutter側に通知する
   * @param  boolean isLoaded (読み込み完了フラグ)
   * @return Promise<void>
   */
  // const homeIsLoadedNotify = async (isLoaded: boolean): Promise<void> => {
  //   try {
  //     await awaitCallHandler();
  //     await window.flutter_inappwebview.callHandler('homeIsLoadedNotify', isLoaded);
  //   } catch (e) {
  //     // NOTE: Web開発時のためのフォールバック
  //     if (import.meta.env.DEV) return;
  //     throw e;
  //   }
  // };

  /**
   * callHandlerがなければ1秒awaitする
   */
  const awaitCallHandler = async () => {
    if (!window.flutter_inappwebview?.callHandler) {
      await new Promise((resolve) => setTimeout(resolve, 1000));
    }
  };

  return {
    openNewWebView,
    launchUrl,
    getUserId,
    setUserId,
    logEvent,
    getAuth,
    registerToken,
    // homeIsLoadedNotify,
  };
};
